import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { eventService } from "../services/event.service";
import { EventRequest } from "../domain/event.interface";

export const useGetEvents = (eventId?: string) => {
	return useQuery({
		queryKey: ["sims-events", eventId],
		queryFn: () => eventService.getEvents(eventId),
		staleTime: 1000 * 60 * 5,
	});
};

export const useGetEvent = (eventId: string) => {
	const query = useQuery({
		queryKey: ["sims-event", eventId],
		queryFn: () => eventService.getEvent(eventId),
		enabled: !!eventId,
		staleTime: 1000 * 60 * 5,
	});

	return {
		...query,
		refetch: query.refetch,
	};
};

export const useCreateEvent = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (event: EventRequest) => eventService.createEvent(event),
		onSuccess: () => {
			// Invalidate and refetch events queries
			queryClient.invalidateQueries({
				queryKey: ["sims-events"],
			});
		},
	});
};

export const useUpdateEvent = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			eventId,
			event,
		}: {
			eventId: string;
			event: Partial<EventRequest>;
		}) => eventService.updateEvent(eventId, event),
		onSuccess: () => {
			// Invalidate and refetch events queries
			queryClient.invalidateQueries({
				queryKey: ["sims-events"],
			});
			queryClient.invalidateQueries({
				queryKey: ["sims-event"],
			});
		},
	});
};

export const useDeleteEvent = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (eventId: string) => eventService.deleteEvent(eventId),
		onSuccess: () => {
			// Invalidate and refetch events queries
			queryClient.invalidateQueries({
				queryKey: ["sims-events"],
			});
		},
	});
};
